<script setup lang="ts">
/**
 * 底部导航。
 *
 * 不用 van-tabbar：设计稿的图标是一套线性图标（stroke 2px），
 * Vant 自带图标是另一套风格，混在一起一眼看得出来。
 * 这里四个图标直接内联 SVG，和 redesign-v2 的一致。
 */
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

const TABS = [
  { name: 'home', label: '积分' },
  { name: 'scan', label: '扫卡' },
  { name: 'products', label: '商城' },
  { name: 'me', label: '我的' },
] as const;

/** 商品详情、结算这些二级页也算在「商城」这一栏下 */
const SECTION: Record<string, string> = {
  product: 'products',
  checkout: 'products',
  orders: 'me',
  ledger: 'home',
  addresses: 'me',
  tasks: 'me',
};

function isActive(name: string): boolean {
  const current = String(route.name);
  return current === name || SECTION[current] === name;
}
</script>

<template>
  <nav class="tabbar" aria-label="底部导航">
    <button
      v-for="t in TABS"
      :key="t.name"
      type="button"
      :class="['tabbar__item', { 'tabbar__item--active': isActive(t.name) }]"
      :aria-current="isActive(t.name) ? 'page' : undefined"
      @click="router.push({ name: t.name })"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <template v-if="t.name === 'home'">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 6v12" />
          <path d="M8 10h8" />
          <path d="M8 14h5" />
        </template>
        <template v-else-if="t.name === 'scan'">
          <path d="M3 7V5a2 2 0 0 1 2-2h2" />
          <path d="M17 3h2a2 2 0 0 1 2 2v2" />
          <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
          <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
          <rect x="7" y="7" width="10" height="10" rx="2" />
        </template>
        <template v-else-if="t.name === 'products'">
          <path d="M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8" />
          <rect x="2" y="7" width="20" height="5" rx="1" />
          <path d="M12 22V7" />
          <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
          <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
        </template>
        <template v-else>
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </template>
      </svg>
      <span>{{ t.label }}</span>
    </button>
  </nav>
</template>
